import React from 'react';
import { Provider } from 'react-redux';
import 'antd/dist/antd.css';
import store from './store';
import PageWrapper from './PageWrapper';
import '../styles/main.scss';

const App = () => (
  <Provider store={store}>
    <PageWrapper />
  </Provider>
);

export default App;
